import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDataTable,{attrs:{"fixed-header":"","items-per-page":-1,"hide-default-footer":"","single-select":"","sort-by":"startTime","sort-desc":true,"height":_vm.kioskAnalyticsDimension.qnaAnalyticsheight,"loading":_vm.loading,"headers":_vm.telepresenceHeader,"items":_vm.callList,"expanded":_vm.expanded,"item-key":"id","single-expand":"","show-expand":""},on:{"update:expanded":function($event){_vm.expanded=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }